<script type="text/javascript">
  const version = "Rev 1.0.1082";
  export default{
    version
  }
</script>



// WEBPACK FOOTER //
// src/const/Version.vue